import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from 'axios';
import { G_API } from '../../constants/globalVar';
import ReactGA from 'react-ga4';
import SocialShareButtons from "../Button/SocialShareButtons";

export default function DetailPage(){
    const { id } = useParams();
    const [item, setItem] = useState(null);

    useEffect(() => {
        var data = '';
        var config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: G_API+'publications/'+id,
            headers: { },
            data : data
        };

        axios(config)
        .then( (response) => {
            const item = response.data.DATAS;
            setItem(item);
        })
        .catch(function (error) {
            console.error(error);
        });
    }, [id]);

    function openShare() {
        ReactGA.event({
            category: 'Publication',
            action: 'publication_share_btn_clicked',
            label: item ? item.title : 'Publication Share',
        });
    }

    function openDownloadLink() {
        ReactGA.event({
            category: 'Publication',
            action: 'publication_download_btn_clicked',
            label: item ? item.title : 'Publication Download',
        });
    }

    return (
        <>
        {item ? (
          <div>
            <div id="header-carousel" className="carousel slide" data-bs-ride="carousel" >
                <div className="carousel-inner" >
                    <div className="carousel-item active">
                        {item.publication_cover_img?.src ? (
                            <img className="w-100 small-slider" src={item.publication_cover_img.src} alt="" />
                        ): (
                            <img className="w-100 small-slider" src='/assets/img9.jpg' alt="" />
                        )}
                        <div className="carousel-caption">
                            <div className="container">
                                <div className="row justify-content-center">
                                    <div className="col-lg-7 pt-0">
                                        <h1 className="display-4 text-white mb-1 mt-2 pt-2 animated slideInDown">
                                            {item.title}
                                        </h1>
                                        <p className="fs-5 text-white-50 mb-5 animated slideInDown">We make free online courses, information sharing events, and volunteer
work for community development</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="container my-4">
                  <div className="row">
                    <div className="col-sm-12 col-md-6 my-4">
                      <div className="px-4 py-4">
                        <h2 className="mb-4">{item.title}</h2>
                        <h6 className="mb-4"><b>Summary</b></h6>
                        <p>
                            <span
                            dangerouslySetInnerHTML={{ __html: item.summary }}
                            />
                        </p>
                        <h6 className="mb-4">Details</h6>
                        <dl className="row">
                            <dt className="col-3">Title</dt>
                            <dd className="col-9">{ item.title}</dd>
                            <dt className="col-3">Author</dt>
                            <dd className="col-9">{ item.author_name }</dd>
                            <dt className="col-3">Published Year</dt>
                            <dd className="col-9">{ item.published_year }</dd>
                            <dt className="col-3">Publisher</dt>
                            <dd className="col-9">{ item.publisher }</dd>
                        </dl>
                        <div className="d-flex justify-content-between py-4">
                            <a className="btn btn-primary rounded-pill" onClick={openDownloadLink} href={item.download_link} disabled={!item.registeration_link} target="_blank" rel="noreferrer">Open Download Link</a>
                            <SocialShareButtons title={item.title} onClick={openShare} />
                        </div>
                      </div>
                    </div>

                    <div className="col-sm-12 col-md-6 my-4">
                        <div className="text-center">
                            {item.publication_cover_img?.src ? (
                            <img className="event-img" src={item.publication_cover_img.src} alt="" style={{ objectFit:'cover',width:'100%' ,minHeight:'500px', height:'auto' }}/>
                            ): (
                            <img className="event-img" src='/assets/images/BlogTemp.png' alt="" style={{ objectFit:'cover',width:'100%' ,minHeight:'500px', height:'auto' }}/>
                            )}
                        </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            ) : <div>
                <span>Loading...</span>
            </div> }
        </>
    );
}
